import React, { useContext } from 'react'
import { AppContext } from './../../providers'
import {
  Step, Icon, Button
} from 'semantic-ui-react'

const Top = () => {
  return (
    <div id="integrator-top-bar">
      <Step.Group fluid>
        <Step>
          <Icon name='location arrow' />
          <Step.Content>
            <Step.Title>Choose a template</Step.Title>
            <Step.Description>
              sdfsdf
          </Step.Description>
          </Step.Content>
        </Step>
        <Step>
          <Icon name='edit' />
          <Step.Content>
            <Step.Title>Design a Message</Step.Title>
            <Step.Description>
              ...
          </Step.Description>
          </Step.Content>
        </Step>
        <Step>
          <Icon name='external alternate' />
          <Step.Content>
            <Step.Title>Custom Preview</Step.Title>
            <Step.Description>...</Step.Description>
          </Step.Content>
        </Step>
        <Step active>
          <Step.Content>
            <Button>Save & Continue</Button>
          </Step.Content>
        </Step>
      </Step.Group>
    </div>
  )
}

const Bottom = () => {
  const { beeAPI } = useContext(AppContext)
  const { store } = beeAPI
  const toggleStructure = () => {
    console.log('Toggle Structure Clicked')
    const { instance } = store
    instance?.toggleStructure()
  }
  const clear = () => {
    console.log('Clear Template Clicked')
    const { instance, template } = store
    instance?.load(template)
  }
  const preview = () => {
    console.log('Preview Clicked')
    const { instance } = store
    instance?.preview()
  }
  const saveAsTemplate = () => {
    console.log('Save As Template Clicked')
    const { instance } = store
    instance?.saveAsTemplate()
  }
  const save = () => {
    console.log('Save HTML Clicked')
    //const { instance } = api
    //instance && instance.save()
  }
  const send = () => {
    console.log('Send Clicked')
    const { instance } = store
    instance?.send()
  }
  const chooseFile = () => {
    console.log('Choose File Clicked')
    const { instance } = store
    instance?.save()
  }


  return (
    <div id="integrator-bottom-bar">
      <span
        className="btnGroup btnGroupLeft"
        style={{ display: 'inline-block', vertcalAlign: 'top' }}
      >
        <span
          style={{ display: 'inline-block', vertcalAlign: 'top' }}
          className="loadTemplate"
        >
          <label htmlFor='choose-template'>Select template to load:</label>
          <input id="choose-template" type="file" />
          <button
            className="btn sendTestButton"
            type="button"
            value="send"
            onClick={() => chooseFile()}
          >
            <i className="fa fa-file"></i>Load file
              </button>
        </span>
      </span>
      <span
        className="btnGroup btnGroupCenter"
        style={{ display: 'inline-block', vertcalAlign: 'top' }}
      >
        <span className="sendTest">
          <span style={{ display: 'inline-block', vertcalAlign: 'top' }} >
            <label htmlFor="integrator-test-emails">Send test e-mail to:</label>
            <input id="integrator-test-emails" type="text" />
          </span>
          <span style={{ display: 'inline-block', vertcalAlign: 'top' }} >
            <button
              className="btn sendTestButton"
              type="button"
              value="send"
              onClick={() => send()}
            >
              <i className="fa fa-envelope"></i>Send</button>
            <strong>|</strong>
          </span>
        </span>
      </span>
      <span
        className="btnGroup btnGroupRight"
        style={{ display: 'inline-block', vertcalAlign: 'top' }}
      >
        <button
          className="btn saveButton"
          type="button"
          value="save"
          onClick={() => save()}
        >
          <i className="fa fa-save"></i> Save HTML
              </button>
        <button
          className="btn saveAsTemplateButton"
          type="button"
          value="save json"
          onClick={() => saveAsTemplate()}
        >
          <i className="fa fa-save"></i>save json
              </button>
        <button
          className="btn previewButton"
          type="button"
          value="preview"
          onClick={() => preview()}
        >
          <i className="fa fa-eye"></i>preview
              </button>
        <button
          className="btn clearButton"
          type="button"
          value="clear"
          onClick={() => clear()}
        >
          <i className="fa fa-eraser"></i>Clear
        </button>
        <button
          className="btn toggleStructureButton"
          type="button"
          value="toggle structure"
          onClick={() => toggleStructure()}
        >
          <i className="fa fa-th"></i>toggle structure
        </button>
      </span>
    </div>
  )
}

const ToolBar = ({ type }) => {
  const { beeAPI } = useContext(AppContext)
  if (!beeAPI) return null

  return  <> { (type === 'bottom') ? <Bottom /> : <Top /> } </>
}

export default ToolBar
